'use strict';

angular.module('shiftTraderApp')
  .controller('DayOffLimitDayHistoryModalCtrl', function($scope, $uibModalInstance, SAErrorHandler, params,
                                            DayOffLimits, DayOffLimitStore, Session, TimeService, limitHistory) {

    var vm = this;

    vm.me = params.me;
    vm.currentDate = params.currentDate;

    vm.startOfWeekDay = Session.getStartOfWeekDay();
    vm.dateToday = TimeService.getNowInStoreTime().toDate();

    vm.limitRecords = limitHistory;

    // records that don't matter...
    // ANY 'day_of_week' type that occur AFTER the first 'exception' type



    vm.close = function() {
      $uibModalInstance.close();
    };
  });
